import { Modal } from "react-bootstrap";
import "./Aminities_Modal.css";
import {
  faLock,
  faShower,
  faPersonDress,
  faHotTub,
  faToilet,
  faShoePrints,
  faSpa,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const facilities = [
  { label: "Locker", icon: faLock },
  { label: "Shower", icon: faShower },
  { label: "Changing Room", icon: faPersonDress },
  { label: "Saunas & Steam Rooms", icon: faHotTub },
  { label: "Washroom", icon: faToilet },
  { label: "Shoe Racks", icon: faShoePrints },
  { label: "Towel Service", icon: faShower },
  { label: "Hydro Massage & Massage Chairs", icon: faSpa },
];

const Aminities_Modal = ({ show, onHide }) => {
  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      size="lg"
      dialogClassName="facility_modal"
      backdrop="static"
    >
      <Modal.Body className="facility_modal_body">
        {/* Header */}
        <div className="facility_modal_header">
          <h5>Amenities Offered</h5>
          <span className="close_btn" onClick={onHide}>
            ×
          </span>
        </div>

        {/* List */}
        <div className="facility_list">
          {facilities.map((item, index) => (
            <div className="facility_item" key={index}>
              <div className="facility_left">
                <FontAwesomeIcon icon={item.icon} />
                <span>{item.label}</span>
              </div>

              <input type="checkbox" className="checkbox" />
            </div>
          ))}
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default Aminities_Modal;
